import classNames from 'classnames';
import styles from '../search-input-suggestions.scss';
import { Spinner, TextButton } from 'wix-ui-tpa';
import { SpinnerTypes } from 'wix-ui-tpa/dist/src/components/Spinner/types';
import SearchResultCommentItem from '../search-result-comment/search-result-comment.component';
import SearchResultPostItem from '../search-result-post/search-result-post.component';
import { unreachable } from '../../../../utils/ts-utils';
import SearchIcon from 'wix-ui-icons-common/on-stage/Search';
import { TextButtonPriority } from 'wix-ui-tpa/dist/src/components/TextButton/types';
import React from 'react';
import { SearchInputSuggestionsState } from '../search-input-suggestions.slice';
import { ForumapiCategory } from '@wix/ambassador-communities/types';
import { TFunction } from '@wix/yoshi-flow-editor';
import { MAX_RESULTS_COUNT } from '../constants/max-results-count';

type SearchResultsStateSwitchProps = {
  state: SearchInputSuggestionsState;
  getCategoryById: (categoryId: string) => ForumapiCategory;
  t: TFunction;
  onMoreResultsClick: () => void;
  onSearchItemClick: () => void;
};

export const SearchResultsStateSwitch: React.FC<SearchResultsStateSwitchProps> = ({
  state,
  t,
  getCategoryById,
  onMoreResultsClick,
  onSearchItemClick,
}) => {
  return (
    <>
      {state.type === 'OPEN' &&
        (() => {
          switch (state.dropdownState.type) {
            case 'LOADING': {
              return (
                <div className={classNames(styles.dropdown, styles.emptyState)}>
                  <Spinner type={SpinnerTypes.slim} diameter={26} />
                  {t('search-input.querying')}
                </div>
              );
            }
            case 'EMPTY': {
              return (
                <div className={classNames(styles.dropdown, styles.emptyState)}>
                  {t('search-input.no-results')}
                </div>
              );
            }
            case 'READY': {
              const data = state.dropdownState.data;
              return (
                <div
                  data-hook="search-suggestions-dropdown"
                  className={classNames(styles.dropdown)}
                >
                  <h4 className={styles.dropdownSection}>
                    {t('search-input.results.posts-and-comments')}
                  </h4>
                  <ul>
                    {data.forumSearchData.entities.map(entity => {
                      switch (entity.type) {
                        case 'comment': {
                          const category = getCategoryById(entity.categoryId);
                          return (
                            <SearchResultCommentItem
                              category={category}
                              comment={entity}
                              query={data.query}
                              onClick={onSearchItemClick}
                            />
                          );
                        }
                        case 'post': {
                          const category = getCategoryById(entity.categoryId!);
                          return (
                            <SearchResultPostItem
                              category={category}
                              post={entity}
                              query={data.query}
                              onClick={onSearchItemClick}
                            />
                          );
                        }
                        default: {
                          unreachable(entity);
                        }
                      }
                    })}
                    {data.forumSearchData.totalCount > MAX_RESULTS_COUNT && (
                      <li data-hook="search-suggestions-dropdown-see-all">
                        <TextButton
                          onClick={onMoreResultsClick}
                          className={classNames(styles.dropdownMoreLink)}
                          prefixIcon={<SearchIcon />}
                          priority={TextButtonPriority.primary}
                        >
                          {t('search-input.results.see-all-results')}
                        </TextButton>
                      </li>
                    )}
                  </ul>
                </div>
              );
            }
            default: {
              return <></>;
            }
          }
        })()}
    </>
  );
};
